.root {
  border: 1px solid hsl(var(--input));
  padding: 0.5rem 0.75rem;
  width: 100%;
  height: 2.5rem;
  border-radius: 0.375rem;
  background: hsl(var(--background));

  &:focus-visible {
    outline: 2px solid #3b82f680;
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}
